export default __webpack_public_path__ + "static/media/runlegs.a8dd0873.png";